import { render } from "./DriverOrders.vue?vue&type=template&id=4a82d44b&scoped=true"
import script from "./DriverOrders.vue?vue&type=script&lang=js"
export * from "./DriverOrders.vue?vue&type=script&lang=js"

import "./DriverOrders.vue?vue&type=style&index=0&id=4a82d44b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a82d44b"]])

export default __exports__